export default [{
    path: '/dashboard',
    name: 'dashboard',
    meta: {
        requiresAuth: true
    },
    children: [{
        path: '/express/list',
        name: 'ExpressList',
        components:{
            
            default: resolve => require(['./list.vue'], resolve)
        }
    },{
        path: '/express/update',
        name: 'ExpressUpdate',
        components:{
            
            default: resolve => require(['./update.vue'], resolve)
        }
    }]
}]


// WEBPACK FOOTER //
// ./src/views/express/router.js